'use strict';
import angular from 'angular';
import './devtools.ctrls';
import './devtools.directives';

angular.module('core.devtools', [
    'core.devtools.ctrls',
    'core.devtools.directives'
]);